export default "__VITE_ASSET__BlyZWH$g__"